import { useState, useRef, useEffect } from 'react';
import { askTutor } from '../api';

function Tutor({ color, context, t }) {
  const contextString = context
    ? `The student is studying GED ${context.subject} — ${context.topic}. The question they just saw: "${context.question.question}". Correct answer: "${context.question.answer}". Explanation: "${context.question.explanation}".`
    : '';

  const initialMessage = context
    ? { role: 'assistant', content: t('tutorContext', context.topic, context.subject) + `\n\n*${context.question.question}*\n\n` }
    : { role: 'assistant', content: t('tutorGreeting') };

  const [messages, setMessages] = useState([initialMessage]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  async function send() {
    const text = input.trim();
    if (!text || loading) return;
    setInput('');

    const userMsg = { role: 'user', content: text };
    const next = [...messages, userMsg];
    setMessages(next);
    setLoading(true);

    try {
      // Build API messages — exclude initial assistant greeting from context (it's UI-only)
      const apiMessages = next
        .filter((_, i) => i > 0) // skip the initial assistant message
        .map(m => ({ role: m.role, content: m.content }));

      const reply = await askTutor(apiMessages, contextString);
      setMessages(prev => [...prev, { role: 'assistant', content: reply }]);
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: t('tutorError') }]);
    } finally {
      setLoading(false);
    }
  }

  function onKey(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  }

  return (
    <div className="tutor-container">
      <div className="tutor-messages">
        {messages.map((m, i) => (
          <div key={i} className={`tutor-msg tutor-msg--${m.role}`}>
            {m.role === 'assistant' && <div className="tutor-avatar">🤖</div>}
            <div className="tutor-bubble">
              {m.content}
            </div>
          </div>
        ))}
        {loading && (
          <div className="tutor-msg tutor-msg--assistant">
            <div className="tutor-bubble typing-indicator">
              <span /><span /><span />
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      <div className="tutor-input-row">
        <textarea
          className="tutor-input"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={onKey}
          placeholder={t('askAnything')}
          rows={2}
        />
        <button
          className="tutor-send"
          style={{ background: color }}
          onClick={send}
          disabled={!input.trim() || loading}
        >
          {t('send')}
        </button>
      </div>
    </div>
  );
}

export default Tutor;
